import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PatientDashboardComponent } from './patient-dashboard/patient-dashboard.component';
import { ActivateMembershipComponent } from './activate-membership/activate-membership.component';
import { TrackRequestComponent } from './track-request/track-request.component';
import { UploadAndEditDocumentsComponent } from './upload-and-edit-documents/upload-and-edit-documents.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { VideoSectionComponent } from './video-section/video-section.component';
import { ViewhealthComponent } from './viewhealth/viewhealth.component';
import { ConsultDoctorComponent } from './consult-doctor/consult-doctor.component';
import { PatientworkflowComponent } from './patientworkflow/patientworkflow.component';
import { MailviewComponent } from './mailview/mailview.component';
import { MessagecenterComponent } from './messagecenter/messagecenter.component';
import { PcomposeEmailComponent } from './pcompose-email/pcompose-email.component';
import { DoctorReportsComponent } from './doctor-reports/doctor-reports.component';
import { UnSavedChangesGuard } from 'src/app/guards/un-saved-changes.guard';
import { AuthPatientGuard } from '../../guards/auth-patient.guard';
import { ROLES } from 'src/app/constant/constant';
import { UserRoleAuthorizeGuard } from 'src/app/guards/user-role-authorize.guard';
import { CouponListComponent } from './coupon-list/coupon-list.component';
import { PackagesComponent } from './packages/packages.component';
import { ActivatedMembersComponent } from './activated-members/activated-members.component';
import { HomeNovspecialComponent } from './home-novspecial/home-novspecial.component';
import { DietSectionComponent } from './diet-section/diet-section.component';
import { EditDataComponent } from './edit-data/edit-data.component';
import { HealthPassportComponent } from './health-passport/health-passport.component';
import { MembershipPlanComponent } from './membership-plan/membership-plan.component';
import { TranslateGuard } from 'src/app/guards/translate.guard';
import { PaymentStatusComponent } from './payment-status/payment-status.component';


const routes: Routes = [
    {
        path: ':slug/patient',
        component: PatientDashboardComponent,
        canActivate: [UserRoleAuthorizeGuard],
        canActivateChild: [UserRoleAuthorizeGuard, AuthPatientGuard],
        data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
        children: [
            {
                path: 'dashboard',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: PatientworkflowComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },
            {
                path: 'edit-data',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: EditDataComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'members/add',
                canDeactivate: [UnSavedChangesGuard],
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: ActivateMembershipComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'activatedmembers',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: ActivatedMembersComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            // {
            //     path: 'healthpassport',
            //     canActivate: [UserRoleAuthorizeGuard],
            //     component: HealthPassportComponent,
            //     data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            // },
            {
                path: 'trackrequest',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: TrackRequestComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'expert-videos',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: VideoSectionComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'uploadandeditdocuments',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: UploadAndEditDocumentsComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'transactions',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: TransactionsComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'health-passport',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: ViewhealthComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
          
            {
                path: 'consultdoctor',
                canDeactivate: [UnSavedChangesGuard],
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: ConsultDoctorComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'messagecenter',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: MessagecenterComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'mailview/:patient_guid/:message_id/:user_guid/:sent',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: MailviewComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'compose-email',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: PcomposeEmailComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'doctorreports',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: DoctorReportsComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'couponcode',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: CouponListComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'packages',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: PackagesComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'Free-Medical-Counseling',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: HomeNovspecialComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'nutrition-and-health',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: DietSectionComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'membership-plan',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: MembershipPlanComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path:'consultdoctor/payment/transaction/checkout/:resultType',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component:PaymentStatusComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path:'packages/payment/transaction/checkout/:resultType',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component:PaymentStatusComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
            {
                path: 'health-passport/payment/transaction/checkout/:resultType',
                canActivate: [UserRoleAuthorizeGuard,TranslateGuard],
                component: ViewhealthComponent,
                data: { role_type: "patient", sub_role: [ROLES["Patient"]] },
            },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PatientRoutingModule { }
